const PrivacyPolicyIcon = ({ ...props }) => (
  <svg viewBox='0 0 24 24' {...props}>
    <path
      d='M4 5h16v14H4z'
      stroke='currentColor'
      strokeWidth='1.4'
      fill='none'
    />
    <path d='M4 9h16' stroke='currentColor' strokeWidth='1.4' />
  </svg>
);

export default PrivacyPolicyIcon;
